<template>
    <div class="pt-2 pb-6 md:py-6">
        <header-component :title="projectStore.project.title"></header-component>
        <div class="max-w-7xl mx-auto px-4 sm:px-4 md:px-8">
          <div v-show="$route.name !== 'projects-edit-content'" class="py-4">
            <route-tabs-component :tabs="tabs"></route-tabs-component>
          </div>
        </div>
      <section class="mx-auto max-w-7xl">
        <div v-if="projectStore.loading && !projectStore.project.uuid" class="px-4 md:px-8 py-12 text-center text-sm text-gray-500">
          <font-awesome-icon class="mr-2 h-5 w-5 animate-spin" icon="spinner"/>
          {{ $t('projects.loading_project') }}
        </div>
        <router-view v-else class="lg:max-w-5xl"></router-view>
      </section>
    </div>
</template>

<script>
    import HeaderComponent from "@/views/common/HeaderComponent";
    import RouteTabsComponent from "@/components/navigation/RouteTabsComponent";
    import {useProjectsStore} from "@/stores/projects";
    import NotificationService from "@/services/notification/NotificationService";

    export default {
        name: "ProjectEditComponent",
        components: {
          HeaderComponent,
          RouteTabsComponent
        },
        setup(){
          const projectStore = useProjectsStore()

          return {
           projectStore
          }
        },
      computed: {
        tabs() {
          const params = { id: this.$route.params.id }

          return [
            {
              to: { name: 'projects-edit', params },
              label: 'projects.general',
              icon: { paths: ['M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'] }
            },
            {
              to: { name: 'projects-content', params },
              label: 'projects.content',
              icon: { paths: ['M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01'] }
            },
            {
              to: { name: 'projects-edit-access', params },
              label: 'projects.access',
              icon: { paths: ['M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636'] }
            },
            {
              to: { name: 'projects-edit-attach-product', params },
              label: 'projects.product',
              icon: { paths: ['M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'] }
            },
          ]
        }
      },
      mounted() {
        this.projectStore.getProject(this.$route.params.id)
            .catch((error) => {
              NotificationService.showApiError(error, this.$t('projects.unexpected_error'))
            })
      },
    }
</script>
